export function DocumentNormal({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1582 3.94727C14.837 4.41685 15.2822 5.2028 15.2822 6.09082V13.1484C15.282 14.5789 14.1102 15.7508 12.6797 15.751H6.31934C4.88866 15.751 3.71698 14.5791 3.7168 13.1484V6.09082C3.7168 5.20345 4.16086 4.41795 4.83887 3.94824C5.00489 5.39918 6.2423 6.53297 7.73633 6.5332H11.2617C12.7562 6.5332 13.9925 5.39873 14.1582 3.94727Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M7.73792 2.25H11.2623C11.6346 2.25 11.9256 2.54896 11.9225 2.90234V3.61523C11.9224 3.98091 11.628 4.27539 11.2623 4.27539H7.7301C7.36439 4.27539 7.07007 3.98091 7.06995 3.61523V2.91016C7.06995 2.54954 7.36694 2.25 7.73792 2.25Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
